module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_3009.1fa25853.png";